export default {
    history: 'ประวัติ',
    date: 'วันที่',
    checkIn: 'เข้างาน',
    checkOut: 'ออก'
}
